import { render } from "./AudioPlayerCustom.vue?vue&type=template&id=4e560e1d&scoped=true"
import script from "./AudioPlayerCustom.vue?vue&type=script&lang=js"
export * from "./AudioPlayerCustom.vue?vue&type=script&lang=js"

import "./AudioPlayerCustom.vue?vue&type=style&index=0&id=4e560e1d&scoped=true&lang=css"

import exportComponent from "/Users/gabrielvoirol/git_projects/df_wpheadless/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e560e1d"]])

export default __exports__